import { createVisitDetailPageActivityUrl } from "src/constants/urls";
import { useMutation } from "src/lib/tanstack-query/hooks/use-mutation";
import { useRouterLocale } from "src/utils/router/use-router-locale";

interface IRequest {
    parameter?: string | null;
    referrer?: string | null;
}

export const useDetailPageActivityMutation = () => {
    const { language, country } = useRouterLocale();
    const { mutate } = useMutation<void, void, IRequest>(createVisitDetailPageActivityUrl(language, country));

    return mutate;
};
